import { useCallback } from 'react';
import { api } from './api-core';
import { UserApi } from './user-api';
import {TCCApi} from './thoughtcocreate-api';
import {MyTwinSpaceApi} from './my-twinspace-api';
import { Chat } from './chat';
import { TopicApi } from './trending-topic-api';
import { WorkshopApi } from './workshop-api';

export interface ICity{
    id:number;
    name:string;
    country_id:string;
}

// var coutryStatic:Promise<ICountry[]>;
export const apiRemote={
    ...UserApi,
    ...TCCApi,
    ...MyTwinSpaceApi,
    ...Chat,
    ...TopicApi,
    ...WorkshopApi
}